import React, { useRef } from "react";
import {
  Box,
  Container,
  Image,
  Heading,
  HStack,
  SimpleGrid,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";


import FlowerIcon from "../../../assets/home/flower.png";
import CircleImage from "../../../assets/home/ycicrcle.png"; // Add your circle image here
import FeedbackImage from "../../../assets/home/imoncircle.png"; // Add your feedback image here
import lightgreen from "../../../assets/home/card/lightgreen.svg";
import brown from "../../../assets/home/card/brown.png";
import sky from "../../../assets/home/card/sky.png";
import Card from "../../home/component/ourprocess/Card";
import Foundersmessage from "./Foundersmessage";
import FlowerImage from "component/FlowerImage";
import cream from '../../../assets/flower/cream.png'
import red from '../../../assets/flower/redd.png'

const Trusted = () => {
  const scrollRef = useRef(null);
  const isDesktop = useBreakpointValue({ base: false, md: true });

  const partner = [
    {
      // title: "Masterchef Matt Preston",
      sorttitle: "Social media is today’s marketplace, and we ensure your brand gets the limelight it deserves. From Facebook to Instagram",
      description: "Matt Preston, Vir Sanghvi",
      shortdescription: "FRONT LAWN",
      image: lightgreen,
    },
    {
      // title: "Our City that Year",
      sorttitle: "Social media is today’s marketplace, and we ensure your brand gets the limelight it deserves. From Facebook to Instagram",
      description: "Geetanjali Shree, Mandira Nayar",
      shortdescription: "FRONT LAWN",
      image: brown,
    },
    {
      // title: "Poor Economics for the Young",
      sorttitle: "Social media is today’s marketplace, and we ensure your brand gets the limelight it deserves. From Facebook to Instagram",
      description: "Esther Duflo, Cheyenne Olivier, Meru Gokhale",
      shortdescription: "CHARBAGH",
      image: sky,
    },
  ];

  // const scroll = (direction) => {
  //   const container = scrollRef.current;
  //   if (container) {
  //     const scrollAmount = container.offsetWidth / 2;
  //     container.scrollBy({
  //       left: direction === "left" ? -scrollAmount : scrollAmount,
  //       behavior: "smooth",
  //     });
  //   }
  // };

  return (
    <Box bg="#f4eddc" color="white">
      <FlowerImage src={cream} top={{base:"71%" ,md:"63%"}} right={{base:"" ,md:"20%"}}/>
      <FlowerImage src={red} top={{base:"75%" ,md:"70%"}} left={{base:"" ,md:"10%"}}/>
      <Container
        py={{ base: 8, md: 12 }}
        maxW="container.xl"
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        position="relative"
      >
        {/* Title Section */}
        <Box position="relative" width="100%" mx="auto" mb={6}>
          <Image src={FlowerIcon} alt="Flower Icon" maxW="180px" mx="auto"  className="fade-in-up"/>
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
          >
            <Heading as="h2" fontSize="3xl" fontWeight="bold" color="black" className="fade-in-up">
              Trusted by People
            </Heading>
          </Box>
        </Box>

        {/* Decorative Circle and Feedback Image */}
        <Box
          position="absolute"
          top={{ base: "15%", md: "8%" }}
          right={{ base: "5%", md: "8%" }}
          width={{ base: "100px", md: "150px" }}
          height={{ base: "130px", md: "180px" }}
        >
          {/* Relative wrapper */}
          <Box position="relative" width="100%" height="100%">
            {/* Circle */}
            <Image
              src={CircleImage}
              alt="Decorative Circle"
              position="absolute"
              top={{ base: "-150%", md: "-40%" }}
              right={{ base: "", md: "90%" }}
              boxSize={{ base: "80px", md: "120px" }}
              data-animated = 'true'
              className="fade-in-up"
            />

            {/* Feedback image */}
            <Image
              src={FeedbackImage}
              alt="Asli Feedback"
              position="absolute"
              top={{ base: "-130%", md: "-20%" }}
              right={{ base: "40px", md: "110%" }}
              boxSize={{ base: "40px", md: "60px" }}
              data-animated = 'true'
              className="fade-in-up"
            />

            {/* Text below feedback image */}
            <Text
              position="absolute"
              top={{ base: "-90%", md: "50px" }}
              right={{ base: "10px", md: "80%" }}
              fontSize={{ base: "sm", md: "md" }}
              fontWeight="bold"
              color="black"
              width="100%"
              textAlign="center"
              className="fade-in-up"
            >
              Asli Feedback
            </Text>
          </Box>
        </Box>

        {/* Scrolling Cards Section */}
        {isDesktop ? (
          <HStack
            spacing={4}
            mt={6}
            width="100%"
            align="center"
            justify="center"
          >
           
            <Box
              ref={scrollRef}
              display="flex"
              overflowX="auto"
              mb={10}
              scrollBehavior="smooth"
              width="100%"
              px={8}
              className="hide-scrollbar"
              css={{
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {partner.map((service, index) => (
                <Box key={index} flex="0 0 33%" mx={2}>
                  <Card service={service} index={index} />
                </Box>
              ))}
            </Box>

          
          </HStack>
        ) : (
          <SimpleGrid columns={1} spacing={6} mt={2} mb={10}>
            {partner.map((service, index) => (
              <Card key={index} service={service} index={index} />
            ))}
          </SimpleGrid>
        )}

        {/* Founder's Message Section */}
        <Foundersmessage />
      </Container>
    </Box>
  );
};

export default Trusted;
